import { MenuItem } from "~/types"
import SetupMenuDrawer from "../../../../../setup/components/SetupMenuDrawer.client"
import { Drawer } from "../../Drawer.client"

type MenuDrawerProps = {
    isOpen: boolean,
    onClose: () => void,
    showCategory: string | boolean,
    setShowCategory: React.Dispatch<React.SetStateAction<string | boolean>>,
    goTo: (path: string) => void,
    storeName: string,
    menuItems: MenuItem[],
    shopSettings: any
}

export default function CustomMenuDrawer({ isOpen, onClose, showCategory, setShowCategory, goTo, storeName, menuItems, shopSettings }: MenuDrawerProps) {
    return (
        <Drawer open={isOpen} onClose={onClose} openFrom="left" heading={storeName} hideLogo={true}>
            <SetupMenuDrawer onClose={onClose} showCategory={showCategory} setShowCategory={setShowCategory} goTo={goTo} storeName={storeName} menuItems={menuItems} shopSettings={shopSettings} />
        </Drawer>
    )
}